import * as React from 'react'
import { Link, RouteComponentProps } from 'react-router-dom'
import { useTable, usePagination, Column, useExpanded } from 'react-table'
import { IDriverSessionFilters, IDriverSessionSearchObject, IDriverSessionHistoryFilters } from '../../types'
import ReactTablePagination from '../ui/ReactTablePagination'
import moment from 'moment'
import UIMessages from 'src/utils/ui-messages'
import { addTime, metersToMiles, secondsToHours } from 'src/utils'
export interface ITableDriverSessionProps {
  filters: IDriverSessionFilters
  sessionHistory: IDriverSessionSearchObject[]
  currentOrganizationId: string
  isFetching: boolean
  error: string
  getCheckInCheckOut: (filters: IDriverSessionHistoryFilters) => Promise<any>
  ownProps: RouteComponentProps<any>
  getDriversSessionList: (filters: IDriverSessionFilters) => Promise<any>
  totalSessions: number
  getManyTripsPerOperator: (filters: IDriverSessionHistoryFilters) => Promise<any>
}

export interface ITableDriversState {
  isArchived: boolean
  search: string
  pages: number
}

interface IProps<T extends object> {
  columns: Array<Column<T>>
  filters: IDriverSessionFilters
  data: T[]
  loading: boolean
  pageCount: number
  totalCount: number
  fetchData: (params: { filters: IDriverSessionFilters; pageIndex: number; pageSize: number }) => void
  renderRowSubComponent: any
  getCheckInCheckOut: any
  getManyTripsPerOperator: (filters: IDriverSessionHistoryFilters) => Promise<any>
}

function SubRowAsync(data: any) {
  const [loading, setLoading] = React.useState(true)
  const [history, setHistory] = React.useState([])
  const [driverTripsLoading, setDriverTripsLoading] = React.useState(true)
  const [driverTrips, setDriverTrips] = React.useState([])
  React.useEffect(() => {
    data
      .getCheckInCheckOut(data.filters)
      .then((data: any) => {
        setHistory(data)
        setLoading(false)
      })
      .catch(() => setLoading(false))

    data
      .getManyTripsPerOperator(data.filters)
      .then((data: any) => {
        setDriverTrips(data)
        setDriverTripsLoading(false)
      })
      .catch(() => setDriverTripsLoading(false))
  }, [])

  return (
    <div>
      <div className='dsh-table-accumulated-hours'>
        <table className='tableInner'>
          <thead>
            <tr>
              <th className='dsh-old-header' scope='col'>
                {UIMessages.driver.checkInTime}
              </th>
              <th className='dsh-old-header' scope='col'>
                {UIMessages.driver.checkOutTime}
              </th>
              <th className='dsh-old-header' scope='col'>
                {UIMessages.driver.duration}
              </th>
            </tr>
          </thead>
          <tbody>
            {loading && (
              <tr>
                <td colSpan={2}>Loading.... </td>
              </tr>
            )}
            {!loading && (
              <React.Fragment>
                {history.map((element: any) => (
                  <tr key={element.id}>
                    <td className='dsh-old-header' data-label='Check in time'>
                      {moment(element.checkInTime)
                        .utc()
                        .format('MM/DD/YYYY hh:mmA')}
                    </td>
                    <td className='dsh-old-header' data-label='Check out time'>
                      {moment(element.checkOutTime)
                        .utc()
                        .format('MM/DD/YYYY hh:mmA')}
                    </td>
                    <td className='dsh-old-header' data-label='Duration'>
                      {element.duration.substr(0, 5)}
                    </td>
                  </tr>
                ))}
              </React.Fragment>
            )}
          </tbody>
        </table>
      </div>
      {driverTrips.length && (
        <div className='dsh-table-trip-details'>
          <table className=' mt1 tableInner'>
            <thead>
              <tr>
                <th className='dsh-table-col-trip-id' scope='col'>
                  {UIMessages.trip.id}
                </th>
                <th className='dsh-table-col-pickup' scope='col'>
                  {UIMessages.trip.scheduledPickUpTime}
                </th>
                <th className='dsh-table-col-dropoff' scope='col'>
                  {UIMessages.trip.scheduledDropOffTime}
                </th>
                <th className='dsh-table-col-service' scope='col'>
                  {UIMessages.trip.service}
                </th>
                <th className='dsh-table-col-product' scope='col'>
                  {UIMessages.trip.product}
                </th>
                <th className='dsh-table-col-estimated-duration' scope='col'>
                  {UIMessages.driver.estimatedDuration}
                </th>
                <th className='dsh-table-col-duration' scope='col'>
                  {UIMessages.driver.duration}
                </th>
                <th className='dsh-table-col-distance' scope='col'>
                  {UIMessages.trip.distance}
                </th>
                <th className='dsh-table-col-fare' scope='col'>
                  {UIMessages.common.fare}
                </th>
                <th className='dsh-table-col-revenue' scope='col'>
                  {UIMessages.common.revenue}
                </th>
                <th className='dsh-table-col-status' scope='col'>
                  {UIMessages.common.status}
                </th>
              </tr>
            </thead>
            <tbody>
              {loading && (
                <tr>
                  <td colSpan={2}>Loading.... </td>
                </tr>
              )}
              {!driverTripsLoading && (
                <React.Fragment>
                  {driverTrips.map((element: any) => {
                    return (
                      <tr key={element.id}>
                        <td className='dsh-table-col-trip-id' data-label='id'>
                          <Link to={`/trips/${element.id}`}>
                            <span className='TransactionId h5 font-blue underline'>{element.id.slice(-8)}</span>
                          </Link>
                        </td>
                        <td className='dsh-table-col-pickup' data-label='Service'>
                          {moment(element.pickup_time)
                            .utc()
                            .format('MM/DD/YYYY hh:mmA')}
                        </td>
                        <td className='dsh-table-col-dropoff' data-label='Service'>
                          {moment(element.completed_time)
                            .utc()
                            .format('MM/DD/YYYY hh:mmA')}
                        </td>
                        <td className='dsh-table-col-service' data-label='Service'>
                          {element.service_name}
                        </td>
                        <td className='dsh-table-col-product' data-label='Product'>
                          {element.product_name}
                        </td>
                        <td className='dsh-table-col-estimated-duration' data-label='Duration'>
                          {secondsToHours(element.estimated_duration)}
                        </td>
                        <td className='dsh-table-col-duration' data-label='Duration'>
                          {secondsToHours(element.duration)}
                        </td>
                        <td className='dsh-table-col-distance' data-label='Distance'>
                          {metersToMiles(element.distance)}
                        </td>
                        <td className='dsh-table-col-fare' data-label='Fare'>
                          {element.fare}
                        </td>
                        <td className='dsh-table-col-revenue' data-label='Revenue'>
                          {element.estimated_fare}
                        </td>
                        <td className='dsh-table-col-status' data-label='Status'>
                          {element.last_status}
                        </td>
                      </tr>
                    )
                  })}
                </React.Fragment>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}

const PAGE_SIZE = 100

function Table<T extends object>({
  columns,
  data,
  fetchData,
  filters,
  loading,
  pageCount: controlledPageCount,
  totalCount,
  renderRowSubComponent,
  getCheckInCheckOut,
  getManyTripsPerOperator
}: IProps<T>) {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    nextPage,
    previousPage,
    setPageSize,
    visibleColumns,
    state: { pageIndex, pageSize }
  } = useTable<T>(
    {
      columns,
      data,
      initialState: { pageIndex: 0 },
      manualPagination: true,
      pageCount: controlledPageCount
    },
    useExpanded,
    usePagination
  )

  React.useEffect(() => {
    const newFilters = {
      ...filters,
      timeZone: moment(filters.fromDate).format('Z')
    }
    fetchData({ filters: newFilters, pageIndex, pageSize })
  }, [filters, pageIndex, pageSize])

  return (
    <React.Fragment>
      <table {...getTableProps()}>
        <thead>
          {headerGroups.map(headerGroup => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map(column => (
                <th {...column.getHeaderProps()}>{column.render('Header')}</th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {loading ? (
            <tr>
              <td>Loading...</td>
            </tr>
          ) : (
            rows.map((row: any, i) => {
              return (
                +prepareRow(row) || (
                  <React.Fragment {...row.getRowProps()}>
                    <tr {...row.getToggleRowExpandedProps()}>
                      {row.cells.map((cell: any, index: any) => {
                        return (
                          <td key={`1-${index}`} {...cell.getCellProps()}>
                            {cell.render('Cell')}
                          </td>
                        )
                      })}
                    </tr>

                    {row.isExpanded && (
                      <tr>
                        <td colSpan={visibleColumns && visibleColumns.length}>
                          {renderRowSubComponent({ row, getCheckInCheckOut, getManyTripsPerOperator, filters })}
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                )
              )
            })
          )}
        </tbody>
      </table>
      <ReactTablePagination
        page={pageIndex}
        pages={controlledPageCount}
        totalCount={totalCount}
        pageSize={pageSize}
        canNext={canNextPage}
        canPrevious={canPreviousPage}
        nextPage={nextPage}
        previousPage={previousPage}
      />
    </React.Fragment>
  )
}

export default function TableDriverViewSessionHistoryOld(props: ITableDriverSessionProps) {
  const [loading, setLoading] = React.useState(false)
  const [revenue, setRevenue] = React.useState(0)
  const [revenuePerHour, setRevenuePerHour] = React.useState(0)
  const [sessionHistory, setSessionHistory] = React.useState(props.sessionHistory)

  // Create a function that will render our row sub components
  const renderRowSubComponent = React.useCallback(({ row, getCheckInCheckOut, getManyTripsPerOperator, filters }) => {
    if (row.original.checkInTime === 'Total') {
      return <div />
    }
    return (
      <SubRowAsync
        getCheckInCheckOut={getCheckInCheckOut}
        getManyTripsPerOperator={getManyTripsPerOperator}
        filters={{
          date: moment(row.original.checkInTime).toISOString(),
          operatorId: filters.operatorId,
          orgId: props.currentOrganizationId
        }}
      />
    )
  }, [])

  const columns = React.useMemo(
    () => [
      {
        id: 'date',
        Header: () => (
          <div style={{ cursor: 'pointer' }} title={UIMessages.driver.driverSessionsHeaderDefinitions.Date}>
            Date
          </div>
        ),
        //Header: 'Date',
        width: 200,
        accessor: (driver: IDriverSessionSearchObject) => {
          return driver.checkInTime === 'Total' ? (
            <div>
              <b>{UIMessages.common.total}:</b>
            </div>
          ) : (
            <div>{moment(driver.modifyDate).format('MM/DD/YYYY')}</div>
          )
        }
      },
      {
        id: 'total_duration',
        Header: () => (
          <div style={{ cursor: 'pointer' }} title={UIMessages.driver.driverSessionsHeaderDefinitions.checkIn}>
            Checked in
          </div>
        ),
        accessor: (driver: IDriverSessionSearchObject) => driver.duration.substr(0, 5),
        className: 'flex items-center'
      },
      {
        id: 'service_duration',
        Header: () => (
          <div style={{ cursor: 'pointer' }} title={UIMessages.driver.driverSessionsHeaderDefinitions.service}>
            Service
          </div>
        ),
        width: 200,
        accessor: (driver: IDriverSessionSearchObject) => {
          const serviceDuration = new Date(driver.service_duration * 1000).toISOString().substr(11, 5)
          return <div>{serviceDuration}</div>
        }
      },
      {
        id: 'trip_duration',
        Header: () => (
          <div style={{ cursor: 'pointer' }} title={UIMessages.driver.driverSessionsHeaderDefinitions.trip}>
            Trip
          </div>
        ),
        width: 200,
        accessor: (driver: IDriverSessionSearchObject) => {
          const duration = new Date(driver.trip_duration * 1000).toISOString().substr(11, 5)
          return <div>{duration}</div>
        }
      },
      {
        id: 'driving_duration',
        Header: () => (
          <div style={{ cursor: 'pointer' }} title={UIMessages.driver.driverSessionsHeaderDefinitions.driving}>
            Driving
          </div>
        ),
        width: 200,
        accessor: (driver: IDriverSessionSearchObject) => {
          const drivingDuration = new Date(driver.driving_duration * 1000).toISOString().substr(11, 5)
          return <div>{drivingDuration}</div>
        }
      },
      {
        id: 'estimated_duration',
        Header: () => (
          <div style={{ cursor: 'pointer' }} title={UIMessages.driver.driverSessionsHeaderDefinitions.estimated}>
            Estimated
          </div>
        ),
        width: 200,
        accessor: (driver: IDriverSessionSearchObject) => {
          const estimatedDuration = new Date(driver.estimated_duration * 1000).toISOString().substr(11, 5)
          return <div>{estimatedDuration}</div>
        }
      },
      {
        id: 'distance',
        // Header: 'Distance(mi)',
        Header: () => (
          <div style={{ cursor: 'pointer' }} title={UIMessages.driver.driverSessionsHeaderDefinitions.distancemi}>
            Distance
          </div>
        ),
        width: 200,
        accessor: (driver: IDriverSessionSearchObject) => {
          const distance = (driver.distance / 1000) * 0.621371
          return <div>{distance.toFixed(2)}</div>
        }
      },
      {
        id: 'completed_trip_count',
        // Header: 'Completed Trip Count',
        Header: () => (
          <div style={{ cursor: 'pointer' }} title={UIMessages.driver.driverSessionsHeaderDefinitions.ctc}>
            Completed Trips
          </div>
        ),
        width: 200,
        accessor: (driver: IDriverSessionSearchObject) => {
          if (driver.completed_trips_count) {
            return <div>{driver.completed_trips_count}</div>
          }
          return <div />
        }
      },
      {
        id: 'assigned_trip_count',
        // Header: 'Assigned Trip Count',
        Header: () => (
          <div style={{ cursor: 'pointer' }} title={UIMessages.driver.driverSessionsHeaderDefinitions.atc}>
            Assigned Trips
          </div>
        ),
        width: 200,
        accessor: (driver: IDriverSessionSearchObject) => {
          if (driver.assigned_trips_count) {
            return <div>{driver.assigned_trips_count}</div>
          }
          return <div />
        }
      },
      {
        id: 'fare',
        // Header: 'Fare(USD)',
        Header: () => (
          <div style={{ cursor: 'pointer' }} title={UIMessages.driver.driverSessionsHeaderDefinitions.fare}>
            Fare (USD)
          </div>
        ),
        width: 200,
        accessor: (driver: IDriverSessionSearchObject) => {
          return <div>{(driver.fare / 100).toFixed(2)}</div>
        }
      },
      {
        id: 'revenue',
        // Header: 'Revenue',
        Header: () => (
          <div style={{ cursor: 'pointer' }} title={UIMessages.driver.driverSessionsHeaderDefinitions.revenue}>
            Revenue
          </div>
        ),
        width: 200,
        accessor: (driver: IDriverSessionSearchObject) => {
          return <div>{(driver.revenue / 100).toFixed(2)}</div>
        }
      }
    ],
    []
  )

  React.useEffect(() => {
    if (props.sessionHistory) {
      const {
        revenue,
        totalHours,
        trip,
        service,
        driving,
        estimated,
        distance,
        completed,
        assigned,
        duration,
        fare
      } = getTotalDetails(props.sessionHistory)
      const revenuePerHour = revenue / 100 / totalHours
      const $PerHour = isNaN(revenuePerHour) ? 0 : revenuePerHour
      const sessionTotalDetails: IDriverSessionSearchObject = {
        checkInTime: 'Total',
        modifyDate: 'Total',
        duration,
        trip_duration: trip,
        estimated_duration: estimated,
        driving_duration: driving,
        service_duration: service,
        distance,
        fare,
        revenue,
        completed_trips_count: completed,
        assigned_trips_count: assigned
      }
      const sessionHistoryArr = props.sessionHistory
      sessionHistoryArr.push(sessionTotalDetails)
      setRevenue(revenue)
      setRevenuePerHour($PerHour)
      setSessionHistory(sessionHistoryArr)
    }
  }, [props.sessionHistory])

  const fetchData = React.useCallback(async ({ filters, pageSize, pageIndex }) => {
    setLoading(true)
    await props.getDriversSessionList({ ...filters, skip: pageIndex * pageSize, take: pageSize })
    setLoading(false)
  }, [])

  const getTotalDetails = (sessionHistory: IDriverSessionSearchObject[]) => {
    let revenue = 0
    let fare = 0
    let trip = 0
    let service = 0
    let driving = 0
    let estimated = 0
    let distance = 0
    let completed = 0
    let assigned = 0
    let breakhours = '00:00:00'
    let duration = '00:00:00'
    sessionHistory.forEach(item => {
      fare = fare + item.fare
      revenue = revenue + item.revenue
      trip = trip + item.trip_duration
      service = service + item.service_duration
      driving = driving + item.driving_duration
      estimated = estimated + item.estimated_duration
      distance = distance + item.distance
      completed = completed + item.completed_trips_count
      assigned = assigned + item.assigned_trips_count
      duration = addTime(duration, item.duration)
      breakhours = breakhours + (item.breakHours || 0)
    })
    const totalHours = trip / 3600
    return {
      fare,
      revenue,
      totalHours,
      trip,
      service,
      driving,
      estimated,
      distance,
      completed,
      assigned,
      duration,
      breakhours
    }
  }

  const pageCount = 1

  return (
    <React.Fragment>
      <div className='font-grey2 bold h5 mt1'>Session History (Old)</div>
      <div className='font-grey2 bold h5 mt1'>
        {`Revenue (USD) per hour:`} <b>{revenuePerHour.toFixed(2)}</b>
      </div>
      <div className='react-table no-padding'>
        <Table
          columns={columns}
          data={sessionHistory || []}
          fetchData={fetchData}
          loading={loading}
          filters={props.filters}
          pageCount={pageCount}
          totalCount={props.totalSessions}
          renderRowSubComponent={renderRowSubComponent}
          getCheckInCheckOut={props.getCheckInCheckOut}
          getManyTripsPerOperator={props.getManyTripsPerOperator}
        />
      </div>
    </React.Fragment>
  )
}



// WEBPACK FOOTER //
// ./src/components/drivers/TableDriverViewSessionHistoryOld.tsx